import React from 'react';
import './users.scss';

import {handleAuthError, useCheckUserAuthentication} from '../../globals';

import { CheckBox } from 'devextreme-react/check-box';
import { useState } from 'react';
import { createStore } from 'devextreme-aspnet-data';
import DataGrid, {
  Column,
  //Button,
  MasterDetail,
  Toolbar,
  Editing,
  Popup,
  Form,
  Selection,
  SearchPanel
} from 'devextreme-react/data-grid';

import { Item} from 'devextreme-react/form';

import { useAuth } from  '../../contexts/auth'; 
//import { useState, useEffect } from "react";
//import {Toolbar, Item} from 'devextreme-react/toolbar';

import roles from './roles.js';

const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Users'



export default function Users() {

  const [isActive, setIsActive] = useState(true);

  const user = useCheckUserAuthentication();

  const filterPayload = { 
    isAttivo: isActive
  };

  const remoteDataSource = createStore({
    key: 'id',
    //loadUrl: serviceUrl + '/GetAction',
    loadUrl: serviceUrl + '/Find',
    onBeforeSend: (method, ajaxOptions) => {
      if (method === "load" ) {           
        var payload = ajaxOptions.data;
        payload.values = JSON.stringify(filterPayload);
        ajaxOptions.data = payload;          
      }     
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}   
    },
    insertUrl: serviceUrl + '/InsertAction',
    updateUrl:serviceUrl + '/UpdateAction',
    deleteUrl: serviceUrl + '/DeleteAction',

    errorHandler: (error) => {
      handleAuthError(error);
    }
    
  });

  function onCheckValueChanged(e)  {
    setIsActive(e.value);
  };

  const addButtonOptions = {
    icon: 'plus',
    hint: 'Nuovo User'
  };

  return (  
  <React.Fragment>
    <h2 className={'content-block'}>Utenti</h2>
    <div className={'content-block'}>
      <div className={'dx-card responsive-paddings'}>
        
      <DataGrid
        dataSource={remoteDataSource}
        focusedRowEnabled={true}
      >
        <Toolbar>
          <Item name="addRowButton"  options={addButtonOptions} location="before"/>
          <Item location="after">
            <CheckBox  
              value={isActive} onValueChanged={onCheckValueChanged}
              defaultValue={isActive}
              text="  Solo Attivi   "
            >
            </CheckBox>
          </Item>    
          <Item name="searchPanel" className="offer-toolbar"/>
        </Toolbar>

        <SearchPanel visible={true} width={240} placeholder="Cerca..." />
        <Selection mode="single" />
        <Editing
          mode="popup"
          useIcons={true}
          allowAdding={true}
          allowDeleting={true}
          allowUpdating={true}     
        >
           <Popup   title= "Utente " showTitle={true} width={600} height={525} />
          <Form>
            <Item itemType="group" caption="" colCount={2} colSpan={2}>
         
              <Item dataField="name" />
              <Item dataField="email" /> 
              <Item dataField="username" />
              <Item dataField="password" /> 
              <Item dataField="isActive" /> 
            </Item>   
          </Form> 
        </Editing>   
        <Column dataField="id" visible={false}/>
        <Column dataField="name" caption="Nome"/>
        <Column dataField="email" visible={false}/>
        <Column dataField="username" />
        <Column dataField="creationDate" caption="Data di creazione"/>
        <Column dataField="password" visible={false}/>
        <Column dataField="isActive" caption="Attivo" width={80}/>

        <MasterDetail
          enabled={true}
          component={roles}
        />
      </DataGrid>  

      </div>
    </div>
  </React.Fragment>
)
};

